import { autoinject } from 'aurelia-dependency-injection';
import { bindable, bindingMode } from 'aurelia-framework';

@autoinject
export class DashboardSummary {
	@bindable({ defaultBindingMode: bindingMode.twoWay }) totalBalance: number;
	@bindable({ defaultBindingMode: bindingMode.twoWay }) lastPaymentDate: Date | null;
	@bindable({ defaultBindingMode: bindingMode.twoWay }) lastPaymentAmount: number;
	@bindable({ defaultBindingMode: bindingMode.twoWay }) nextPaymentDate: Date | null;

	showLastPayment: boolean;
	showNextPayment: boolean;

	lastPaymentDateChanged() {
		this.updateFieldsDisplayed();
	}

	lastPaymentAmountChanged() {
		this.updateFieldsDisplayed();
	}

	nextPaymentDateChanged() {
		this.updateFieldsDisplayed();
	}

	updateFieldsDisplayed() {
		this.showLastPayment = (this.lastPaymentDate !== undefined && this.lastPaymentDate != null && this.lastPaymentAmount !== undefined);
		this.showNextPayment = (this.nextPaymentDate !== undefined && this.nextPaymentDate != null);
	}
}
